import template from './google-stars.html';
import './google-stars.global.css';

export class GoogleStarsController {
  get stars() {
    // Round `this.value` to nearest multiple of .5, capping at 5.
    const value = Math.min(Math.round(this.value * 2) / 2, 5);

    return Array(5)
      .fill(0)
      .map((currentValue, index) => {
        if (value === index + 0.5) {
          return 0.5;
        } else if (value > index) {
          return 1;
        } else {
          return currentValue;
        }
      });
  }
}

export const GoogleStarsComponent = {
  template,
  controller: GoogleStarsController,
  bindings: {
    value: '<',
  },
};
